import './helpers.js';
import './config.js';
import { b as registerComponent, u as use } from './plugins-678fd904.js';
import './Icon-631c5342.js';
import './FormElementMixin-97156cdb.js';
import './Input-90b0bfda.js';
import './MatchMediaMixin-58956a9c.js';
import './trapFocus-25a621e6.js';
import './DropdownItem-099891fe.js';
import './Field-38e21e8c.js';
import './Select-5d87fddf.js';
import { _ as __vue_component__ } from './Datepicker-4ac43765.js';
export { _ as ODatepicker } from './Datepicker-4ac43765.js';

const Plugin = {
  install(Vue) {
    registerComponent(Vue, __vue_component__);
  }

};
use(Plugin);

export default Plugin;
